import { render } from "./ScreenTemplateBuilder.vue?vue&type=template&id=87623d60"
import script from "./ScreenTemplateBuilder.vue?vue&type=script&lang=js"
export * from "./ScreenTemplateBuilder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__